import type { ButtonConfig } from '../declare'
import * as Row from './row'
import { $consts } from 'src/plugins'

/**
 * 列表表单表格行按钮
 * @param props 
 * @returns 
 */
const RowButton = (props: { config: ButtonConfig }) => {
  const { BTN_TYPE } = props.config
  switch (BTN_TYPE) {
    // 列表行编辑按钮
    case $consts['TABLE/BTN_TYPE_EDIT_PAGE']:
      return <Row.TableRowEdit config={props.config} />
    // 自定义弹窗按钮
    case $consts['TABLE/BTN_TYPE_CUSTOM_PAGE']:
      return <Row.CustomModalBtn config={props.config} />
    // 删除按钮
    case $consts['TABLE/BTN_TYPE_DELETE']:
      return <Row.DeleteConfirmBtn config={props.config} />
    // 查看按钮
    case $consts['TABLE/BTN_TYPE_VIEW']:
      return <Row.ViewModalBtn config={props.config} />
    // 列表弹窗按钮
    case $consts['TABLE/BTN_TYPE_LIST_PAGE']:
      return <Row.ListModalBtn config={props.config} />
    // 编辑树弹窗按钮
    case $consts['TABLE/BTN_TYPE_EDITTREE_PAGE']:
      return <Row.EditTreeModalBtn config={props.config} />
    default:
      return <div />
  }
}

export default RowButton